import { render, staticRenderFns } from "./ModattaTimeline.vue?vue&type=template&id=260c37b8"
import script from "./ModattaTimeline.vue?vue&type=script&lang=js"
export * from "./ModattaTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports